
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import color from '../shared/color'
import { ChoroplethUS, DonutChart, ScatterPlot, StackBarChart } from '../d3'
import { Typography, Grid, CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../story.css'

function DevOpsKPI_DeploymentTime() {

    const [title] = useState("Deployment Time - DevOpsKPI")
    const [summary] =  useState("Key Performance Indicators of Software deployment and development in BD MMS for Deployment Time.")
    const [categories] = useState(["BiRocket","implementation"])
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const [filterLayout] = useState([
        {column:"Column", field:"column_name"},
        {column:"Filter Value", field: "value_name"},
        {column:"Product Type",field:"producttype"}
    ])
    const [revLayout] = useState([
        {column:"Grouping Value", field:"grouping"},
        {column:"Result", field: "value_name"}
    ])
    const [tfsLayout] = useState([
        {column:"Established TFS Value", field:"tfsValue"}
    ])

    const [bubbleColor, setBubColor] = useState(null)
    const useStyles = makeStyles({
        table: {
            minWidth: 650,
        },
    })

    let history = useHistory()

    useEffect(() => {
        setBubColor(new Map([
            ["Scheduled_with_permission", "#4e79a7"],
            ["Customer_Managed", "#f28e2c"],
            ["Scheduled_wo_permission", "#59a14f"]
          ]))
        async function fetch() {
            await API.get('qs-web-api', '/data/DevOpsKPI_DeploymentTime/DevOpsKPI_DeploymentTime.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])

    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        Deployment time metric helps measure how long it takes to deploy a release into a development, testing or production environment. Measuring this metric can help improve deployment and delivery methods, processes and tools.
                         </p>
                         <p>
                         <a href="/DevOpsKPI">Devops KPIs</a>
                         </p>

                         <p>
                         <a href="https://statics.teams.cdn.office.net/evergreen-assets/safelinks/1/atp-safelinks.html">Pyxis ES Release Schedule - DRAFT - Pyxis ES - Confluence (atlassian.net)</a>.
                         </p>



                        </Typography>
                        </div>
                    </Grid>
                </Paper>








            </div >
        )
    }
}

export default DevOpsKPI_DeploymentTime